// Б.1.d: Дилер — order при размещении.
// «Призывает случайную Модификацию из колоды в руку».
// Из КОЛОДЫ (не общего пула фракции — отличается от Рипера/Раста).

export const CARD_ID = 'syn_diler';

export function dilerOrder(state, ownerIdx /* , card */) {
  const p = state.players[ownerIdx];
  const modsInDeck = p.deck.filter(c => c.type === 'mod');
  if (modsInDeck.length === 0) {
    state.log.add(`📦 Дилер [${p.name}]: в колоде нет Модов`);
    return;
  }
  const idx = state.rng.int(modsInDeck.length);
  const card = modsInDeck[idx];
  const deckIdx = p.deck.indexOf(card);
  if (deckIdx >= 0) p.deck.splice(deckIdx, 1);
  if (p.hand.length >= 10) {
    p.discard.push(card);
    state.log.add(`📦 Дилер [${p.name}]: ${card.name_ru} сгорает (рука полна)`);
  } else {
    p.hand.push(card);
    state.log.add(`📦 Дилер [${p.name}]: +Мод из колоды (${card.name_ru})`);
  }
}
